(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["eternl-product-details"] && !Shopify.designMode) return;
  try {
    function openEternlSizeGuide() {
    const guide = document.getElementById('size-guide');
    if (!guide) return;
    if (guide.tagName === 'DETAILS') guide.open = true;
    const heading = guide.querySelector('summary') || guide;
    heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
    guide.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
  document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-el-size-link]');
    if (!link) return;
    event.preventDefault();
    openEternlSizeGuide();
  });
  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#size-guide') openEternlSizeGuide();
  });
  if (window.location.hash === '#size-guide') openEternlSizeGuide();
  } catch(e) { console.error(e); }
})();

})();
